import { isWcmEditor } from "config/serverConfig";
import { PayWallWrapper } from "./paywallWrapper";
import { PremiumPaywallDesktop } from "../../../widgets/defenitions/paywallForms/desktop/premiumPaywallDesktop"
import { PremiumPaywallMobile } from "../../../widgets/defenitions/paywallForms/mobile/premiumPaywallMobile"

import { injectPageComponentaContext } from "widgets/commonComponents/base/injectPageComponentaContext"
import { PageComponentaContext } from "../../../widgets/interfaces";
import { PremiumCalcalistPaywallMobile } from "../../../widgets/defenitions/calcalist/calcalistPaywallForms/mobile/premiumCalcalistPaywallMobile"
import { PremiumCalcalistPaywallDesktop } from "../../../widgets/defenitions/calcalist/calcalistPaywallForms/desktop/premiumCalcalistPaywallDesktop"



export interface SiteArticlePremiumCutterProps {
    resourceId: string;
    siteName?: string;
}

declare const window: Window & {
    DISABLE_PAYWALL_CUTTER?: boolean;
}

 
export class SiteArticlePremiumCutter extends React.Component<SiteArticlePremiumCutterProps, {}> {
    public static siteScriptName = "SiteArticlePremiumCutter";
    public render() {
        const { resourceId, siteName } = this.props;
        const disablePaywallCutter = typeof window !== "undefined" && window.DISABLE_PAYWALL_CUTTER;
        let isPiano = typeof window != "undefined" && window.YitPaywall && window.YitPaywall.isPianoLogin;
        const isMobile = typeof window !== "undefined" && window.isMobile1;
        let UICompoennt = null
        switch (siteName) {
            case "ynet":
            case "pplus":
                UICompoennt = isMobile ? PremiumPaywallMobile : PremiumPaywallDesktop;
                break;
            case "calcalist":
                //UiComponentCalcalist = isMobile ? PremiumCalcalistPaywallMobile : PremiumCalcalistPaywallDesktop;
                break;
        }
        if ( isWcmEditor() || disablePaywallCutter || isPiano) {
            return null;
        }

        return (
            //  @ts-ignore
            <PayWallWrapper resourceId={resourceId}>
                < UICompoennt />
            </PayWallWrapper>
        );

    }
}


export default SiteArticlePremiumCutter;